import { useState, useEffect, useContext, useRef } from "react";
import { autohealConfiguration } from "../../../api/automation/autoheal_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Card, Input, Subtitle2, Dropdown, Link, Image, Tooltip, Spinner } from "@fluentui/react-components";
import { Delete20Regular, SaveCopy20Regular, ColumnTripleEdit20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, CalendarClock20Regular, Wand20Regular, SettingsCogMultiple20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, AddSquare20Regular, Copy20Regular, ArrowMaximize20Regular, DismissSquare24Filled, SlideEraser20Regular, Info24Filled, Dismiss16Regular, Open20Regular, Info20Filled, CheckmarkLock20Regular, AlertBadge20Regular, BrainCircuit20Regular, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Checked } from "../../../components/switch/switch.component";
import { Inputs } from "../../../components/textarea/input.component";
import { Intent } from "../../../components/messagebar/messagebar.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Activity_log_func } from "../../../api/activity_log/activity_log_func";
import { fullscreenIcon, primaryIcon, secondaryIcon, exitIcon, lightTheme, messageTheme, overflowDivider, buttonContent, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AutomationPages } from "../../../components/side_menu/InlineSidenav";

const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

export const Autoheal = () => {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  var dartNo: any = contextValue.dartNo;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [activeTab, setActiveTab] = useState('Intro');
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [dartSpecs, setDartSpecs]: any = useState([]);
  const [automationOverLayData, setAutomationOverLayData]: any = useState([]);
  const [jsonSchema, setJsonData]: any = useState({});
  const [uiSchema, setUiData]: any = useState({});
  const [formData, setFormData]: any = useState({
    name: '',
    description: '',
    jsonData: ''
  });
  const [formEditedData, setFormEditedData]: any = useState({
    name: '',
    description: '',
    jsonData: ''
  });
  const [deleteAutomation, setDeleteAutomation]: any = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [rowID, setRowID]: any = useState(null);
  const [automationSearchVal, setAutomationSearchVal] = useState('');
  const [tracker, setTracker] = useState(false);
  const [userActivityData, setUserActivityData] = useState({});
  const [automationStatus, setAutomationStatus] = useState('not attached');
  const [errorToast, setErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [classificationNameValidation, setClassificationNameValidation]: any = useState(true);
  const [selectedAutomation, setSelectedAutomation] = useState('');
  const [isFullScreen, setIsFullScreen] = useState(false);
  // const [permissions, setPermissions] = useState(['']);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);

  const handle = useFullScreenHandle();

  useEffect(() => {
    if (overlayOpen) {
      const element = document.getElementById("fluent-default-layer-host");
      if (element) {
        element.style.zIndex = '9999999';
      }
    }
  }, [overlayOpen])

  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
  const [disableConfirmBtn, setDisableConfirmBtn] = useState(false);

  useEffect(() => {
    // Direct, simple filtering
    const matchingData = final_data?.filter(
      item => 
        contextValue?.selectedRowIdInTable.includes(item.id) && 
        item.status !== "not attached"
    ) || [];
  
    // Set disable state based on matching data
    setDisableConfirmBtn(matchingData.length > 0);
  }, [contextValue?.selectedRowIdInTable]);

  useEffect(() => {
    const createdByOptions = uniqueCreatedBy.map((item) => {
      return { key: item, label: <Caption1>{item}</Caption1>, };
    });
    setCreatedBy(createdByOptions);
    console.log("Created By Options:", createdByOptions);
  }, [uniqueCreatedBy]);
  const [isFilter, setIsFilter] = useState(false);
  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    // if(value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
    // }
  }

  const handleCloseFilter = (index: any): any => {
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }
  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    }
    else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1 === ("Name") || dropDownValue1 === ("Description") || dropDownValue1 === ("Status")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    // if (name === 'filter' && dropDownValue1 === ("Created By")) {
    //   if(regexS.test(enteredValue)){
    //     setDropDownValue2(enteredValue);
    //     }
    // }
  }

  var timer: any = '';
  const handleNewFormChange = (e: any) => {
    if (e.formData?.AutomationExecute?.length > 0) {
      timer = clearTimeout(timer);
      timer = setTimeout(() => {
        setAutomationSearchVal(e.formData.AutomationExecute);
      }, 1000);
    }

    setFormData({
      ...formData,
      jsonData: e.formData
    });
  }

  useEffect(() => {
    var flag = true;
    exportDetails.map((val: any) => {
      if (val.automationName === formData.name || (overlayName === 'editAutomation' && val.automationName === formEditedData.name)) {
        flag = false;
      }
    });

    if (overlayName === 'editAutomation' && formEditedData.name === selectedAutomation) {
      flag = true;
    }

    setClassificationNameValidation(flag);
  }, [formData, formEditedData, selectedAutomation]);

  const handleEditFormChange = (e: any) => {
    setFormEditedData({
      ...formEditedData,
      jsonData: e.formData
    });
  }
  const buttonref: any = useRef(null);
  const handleOutsideButton = () => {
    buttonref?.current?.click();
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
  }

  //data table column name code starts here
  // var columns = [
  //   { key: "name", label: <Body1Strong> Name </Body1Strong> },
  //   { key: "description", label: <Body1Strong> Description </Body1Strong> },
  //   { key: "created_by", label: <Body1Strong> Created by </Body1Strong> },
  //   { key: "created_on", label: <Body1Strong> Created On (UTC) </Body1Strong> },
  //   { key: "created_on_timezoned", label: <Body1Strong> Created On ({formattedTimeZone}) </Body1Strong> },
  //   { key: "last_modified", label: <Body1Strong> Last Modified (UTC) </Body1Strong> },
  //   { key: "last_modified_timezoned", label: <Body1Strong> Last Modified ({formattedTimeZone}) </Body1Strong> },
  //   { key: "status", label: <Body1Strong> Status </Body1Strong> },
  // ];
  //data table column name code ends here
  //fiter table clolumn start here
  // var columns1 = [
  //   { key: "name", label: <Caption1> Name </Caption1> },
  //   { key: "description", label: <Caption1> Description </Caption1> },  
  //   { key: "created_by", label: <Caption1> Created by </Caption1> },
  //   { key: "created_on", label: <Caption1> Created On </Caption1> },
  //   { key: "last_modified", label: <Caption1> Last Modified </Caption1> },
  //   { key: "status", label: <Caption1> Status </Caption1> },
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Automation?.Autoheal.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Automation?.Autoheal.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "Automation", page: "Autoheal" });
  }, [contextValue.tableColumnsData]);

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        {/* <Stack tokens={{childrenGap:10}} horizontal> */}
        {permissions.includes("all") || permissions.includes("autoheal_Fullaccess") ?

          <StackItem onClick={() => { setOverlayOpen(true); setAutomationStatus('not attached'); setOverlayName('addAutomation'); setFormData({ ...formData, name: '', description: '', jsonData: '' }); }}>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
              {/* <Stack tokens={{childrenGap:6}}>
                <StackItem><Text></Text></StackItem> */}
              <StackItem>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>{loading ?
                    <AddSquare20Regular {...secondaryIcon} />
                    : <AddSquare20Regular {...primaryIcon} />}</StackItem>
                  <StackItem> <Caption1> Create Auto-Heal </Caption1> </StackItem>
                </Stack>
              </StackItem>
              {/* </Stack> */}
            </Button>
          </StackItem>
          :
          <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem><Text></Text></StackItem>
                <StackItem>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                    <StackItem><Caption1> Create Auto-Heal </Caption1></StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </Button>
          </Tooltip>
        }

        <StackItem>
          <Divider vertical />
        </StackItem>

        {/* <StackItem>
            <Button shape="circular" appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                <StackItem>
                  <Stack tokens={{childrenGap:5}} horizontal>
                    <StackItem> <SaveCopy20Regular {...primaryIcon}/> </StackItem>
                    <StackItem> <Caption1> Duplicate </Caption1> </StackItem>
                  </Stack>
                </StackItem>
            </Button>
          </StackItem>
 
          <StackItem>
        <Divider vertical/>
        </StackItem> */}

        <StackItem>
          <DialogBox
            headerButton={
              <>
                <Button shape="circular" appearance="transparent" size="small"
                  disabled={isdeletedisabled ? true : false} >
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>
                      {/* <Delete20Regular {...primaryIcon} /> */}
                      {isdeletedisabled
                        ? (<Delete20Regular {...secondaryIcon} />)
                        : (<Delete20Regular {...primaryIcon} />)
                      }
                    </StackItem>
                    <StackItem> <Caption1> Delete </Caption1> </StackItem>
                  </Stack>
                </Button>
              </>
            }

            content={disableConfirmBtn ? "Enabled automation cannot be deleted. Please disable or unselect the enabled automation and try again." : "Please confirm if you want to proceed with deleting the automation."}

            footer=
            {
              <>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    <Button shape="circular" disabled={disableConfirmBtn} appearance="primary" onClick={() => { setDeleteAutomation(true); /*userActivity('Delete', `{"summary":"${contextValue.selectedRowIdInTable.length} autoheal automations deleted"}`);*/ }} size="small">Confirm</Button>
                  </StackItem>
                  <StackItem>
                    <Button shape="circular" size="small">Cancel</Button>
                  </StackItem>
                </Stack>
              </>
            }
          />
        </StackItem>

        <StackItem>
          <Divider vertical />
        </StackItem>

        {/* <Stack tokens={{childrenGap:6}}> */}
        {/* <StackItem><Text></Text></StackItem> */}
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        {permissions.includes("all") || permissions.includes("autoheal_Fullaccess") || permissions.includes("autoheal_ReadandExport") ?

          <StackItem>
            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_autoheal_automations.csv`}>
            </CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); /*userActivity('Export', `{"summary":"Autoheal automation list exported"}`);*/ }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem><Text></Text></StackItem>
                <StackItem>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                    <StackItem><Caption1> Export </Caption1></StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </Button>
          </Tooltip>
        }

        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
        {/* </Stack>
        </Stack> */}
      </>
    ,
  };

  useEffect(() => {
    if (dartSpecs?.length > 0) {
      console.log("formData=", formData);
      console.log("editData=", formEditedData);
      console.log("overlayName=", overlayName);

      console.log("jsonSchema", jsonSchema)

      var details = dartSpecs.length > 0 ? dartSpecs[0].details : "{}";
      details = JSON.parse(details);

      overlayName === 'addAutomation' && setAutomationOverLayData({
        headerTitle: "Create Auto-Heal",
        size: "large",
        isTabs: true,
        tabItems: {
          Introduction: <form id="myFormAutoheal" onSubmit={(e) => handleSubmit(e)}> <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <p> <b>Name<Image src="/Dashboard/image/required.svg" /></b></p>
            </StackItem>
            <StackItem>
              <p> <Inputs inputChange={setFormData} inputVal={formData} required={true} /></p>
              {!classificationNameValidation && <Body1>This automation name already exists</Body1>}
            </StackItem>

            <StackItem>
              <p> <b>What does this Automation Do?</b></p>
            </StackItem>
            <StackItem>
              <p> <Resize inputChange={setFormData} inputValue={formData} /></p>
            </StackItem>

            <InfoBar title={"These are the basic details associated with this automation."} />
            {Object.keys(details).map(key => (
              <>
                <StackItem>
                  <p><b>{key}</b></p>
                </StackItem>
                <StackItem>
                  <p>{details[key]}</p>
                </StackItem>
              </>
            ))}
          </Stack>
            <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
          </form>,

          Configuration:
            <Form ref={formRef} formData={formData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange(e)} />,

          "Review Data":
            <>
              <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                <StackItem>
                  {/* <p> <b>Name</b></p> */}
                  <Body1Strong>Name</Body1Strong>
                </StackItem>
                <StackItem>
                  <p> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /></p>
                </StackItem>

                <StackItem>
                  {/* <p> <b>What does this Automation Do?</b></p> */}
                  <Body1Strong>What does this Automation Do?</Body1Strong>
                </StackItem>
                <StackItem>
                  <p> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /></p>
                </StackItem>
                <Form formData={formData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
              </Stack>
            </>
        }
      });
    }

    Object.keys(formData).length > 0 && overlayName === 'editAutomation' && automationStatus === 'not attached' && setAutomationOverLayData({
      headerTitle: `Edit ${selectedAutomation}`,
      size: "large",
      isTabs: true,
      tabItems: {
        Introduction:spinnerLoad?
        <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
        <Spinner/>
        </Stack>: <form id="myFormAutoheal" onSubmit={(e) => handleSubmit(e)}> <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            <p> <b>Name<Image src="/Dashboard/image/required.svg" /></b></p>
          </StackItem>
          <StackItem>
            <p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} required={true} /></p>
            {!classificationNameValidation && <Body1>This automation name already exists</Body1>}
          </StackItem>

          <StackItem>
            <p> <b>What does this Automation Do?</b></p>
          </StackItem>
          <StackItem>
            <p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} /> </p>
          </StackItem>
          {Object.keys(details).map(key => (
            <>
              <StackItem>
                <p><b>{key}</b></p>
              </StackItem>
              <StackItem>
                <p>{details[key]}</p>
              </StackItem>
            </>
          ))}
        </Stack>
          <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
        </form>,

        Configure: <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <Form ref={formRef} formData={formEditedData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} onChange={(e) => handleEditFormChange(e)} />
        </Stack>,

        "Review Data":
          <>
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <StackItem>
                {/* <p> <b>Name</b></p> */}
                <Body1Strong>Name</Body1Strong>
              </StackItem>
              <StackItem>
                <p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                {/* <p> <b>What does this Automation Do?</b></p> */}
                <Body1Strong>What does this Automation Do?</Body1Strong>
              </StackItem>
              <StackItem>
                <p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} disabled={true} /></p>
              </StackItem>
              <Form formData={formEditedData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
            </Stack>
          </>
      }
    });

    Object.keys(formData).length > 0 && overlayName === 'editAutomation' && automationStatus !== 'not attached' && setAutomationOverLayData({
      headerTitle: `${selectedAutomation} automation`,
      size: "large",
      isTabs: true,
      tabItems: {
        Configuration:spinnerLoad?
        <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
        <Spinner/>
        </Stack>:
          <>
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <InfoBar showSpaces={false} title={"Editing is disabled for this automation as it is associated with a Tenant or Device Classification. To make changes, please detach it first."} />
              <StackItem>
                <p> <b>Name</b></p>
              </StackItem>
              <StackItem>
                <p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                <p> <b>What does this Automation Do?</b></p>
              </StackItem>
              <StackItem>
                <p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} disabled={true} /></p>
              </StackItem>
              <Form formData={formEditedData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
            </Stack>
          </>
      }
    });
  }, [dartSpecs, overlayName, formData, formEditedData, classificationNameValidation]);
  // overflow set contents code ends here

  var tempTableData: any = [];

  useEffect(() => {
    var tempExportData: any = [];
    var status = '';

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      if (val.status == 'not attached') {
        status = 'Not attached';
      } else {
        var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

        if (curStatus.length === 0) {
          status = 'Enabled for other tenant';
        } else {
          curStatus = curStatus[0]?.split(":")[1];

          if (curStatus == 'all') {
            status = 'Enabled for All Devices';
          } else {
            status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
          }
        }
      }

      tempExportData.push({
        'Name': val.automationName,
        'Description': val.description,
        'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
        'Created On': convertToExcelFormat(val.createdOn),
        'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
        'Status': status
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  // useEffect(() => {
  //   //roles and permissions
  //   async function loadRoute() {
  //     console.log("role:-",sessionStorage.getItem('role'))
  //     const role = sessionStorage.getItem('role');

  //     try {
  //       const [routeAllowed, permissions] = await shouldLoadRoute(role);

  //       if (routeAllowed) {
  //         console.log("permission===",permissions);

  //         setPermissions(permissions)
  //       } else {
  //         console.log('Route is not allowed.');
  //       }
  //     } catch (error) {
  //       console.error('Error loading route:', error);
  //     }
  //   }

  //   loadRoute();
  // }, []);

  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];

      final_data?.forEach((val: any) => {
        if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
          newUniqueCreatedBy.push(val.createdBy);
        }
      });

      setUniqueCreatedBy(newUniqueCreatedBy);
      console.log("Unique Created By:", newUniqueCreatedBy);
    } else {
      setUniqueCreatedBy([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here
    console.log("final_data=", final_data);
    var status = '';

    final_data !== undefined && final_data !== null ?
      final_data?.map((val: any, i: any) => {
        if (val.status == 'not attached') {
          status = 'Not attached';
        } else {
          var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

          if (curStatus.length === 0) {
            status = 'Enabled for other tenant';
          } else {
            curStatus = curStatus[0]?.split(":")[1];

            if (curStatus == 'all') {
              status = 'Enabled for All Devices';
            } else {
              status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
            }
          }
        }
        {
          permissions.includes("all") || permissions.includes("autoheal_Fullaccess") ?

            tempTableData.push({
              id: val.id,
              checkbox: "show" ,
              name: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={(e: any) => { setRowID(val.id); setOverlayOpen(true); setOverlayName('editAutomation'); val.status.includes(`${contextValue.tenantName}:`) ? setAutomationStatus('attached') : setAutomationStatus('not attached'); setSelectedAutomation(val.automationName); setSpinnerLoad(true)}}> {val.automationName} </Button> },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
            :
            tempTableData.push({
              id: val.id,
              checkbox: "hide",
              name: {
                label:
                  <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                    <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.automationName} </Button>
                  </Tooltip>
              },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
        }
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  useEffect(() => {
    !overlayOpen && setOverlayName('');
  }, [overlayOpen]);

  const userActivity = (action: String, activity: String, status: any = 'Success') => {
    setUserActivityData({ pageName: 'Autoheal', moduleName: "Automation", action: action, time: Math.floor(Date.now() / 1000), activity: activity, status: status });

    setTracker(true);
  }

  useEffect(() => {
    if (saveBtnClicked) {
      // overlayName == 'addAutomation' && userActivity('Add', `{"automationName":"${formData.name}","configuration":${JSON.stringify(formData.jsonData)},"type":"Autoheal","dartNo":"69","summary":"${formData.name} automation is created"}`);

      // overlayName == 'editAutomation' && userActivity('Edit', `{"automationName":"${formData.name}","configuration":${JSON.stringify(formEditedData.jsonData)},"type":"Autoheal","dartNo":"69","summary":"${formEditedData.name} automation is edited"}`);
    }
  }, [saveBtnClicked]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    const pageNo = (currentPageNo - 1) * 50;

    const props: any = {
      selectedRowIdInTable: contextValue.selectedRowIdInTable,
      tenant: tenantName,
      dartNo: dartNo,
      data: final_data,
      func: set_final_data,
      searchVal: searchVal,
      pageNo: pageNo,
      setTotalPages: setTotalPages,
      setTotalRecords: setTotalRecords,
      isFilter: isFilter,
      setIsFilter: setIsFilter,
      dropDownValue1: dropDownValue1,
      dropdownValue2: dropDownValue2,
      setDartSpecs: setDartSpecs,
      setJsonData: setJsonData,
      setUiData: setUiData,
      deleteAutomation: deleteAutomation,
      setDeleteAutomation: setDeleteAutomation,
      setDeleteDisabled: setDeleteDisabled,
      isRefresh: isRefresh,
      setIsRefresh: setIsRefresh,
      setRefreshToast: setRefreshToast,
      filterArray: filterArray,
      setIsToast: setIsToast,
      setExportDetails: setExportDetails,
      overlayName: overlayName,
      setErrorToast: setErrorToast,
      setToastMessage: setToastMessage,
      setOverlayOpen: setOverlayOpen,
      setSaveBtnClicked: setSaveBtnClicked,
      jsonSchema: jsonSchema,
      rowID: rowID,
      automationSearchVal: automationSearchVal,
      saveBtnClicked: saveBtnClicked,
      dartSpecs: dartSpecs,
      exportBtnClicked: exportBtnClicked,
      setExportBtnClicked: setExportBtnClicked,
      setLoading: setLoading,
      setSpinnerLoad: setSpinnerLoad
    }

    if (saveBtnClicked) {
      props.newData = overlayName == 'addAutomation' ? formData : formEditedData;
      props.setFormData = overlayName === 'addAutomation' ? setFormData : setFormEditedData;
    } else if (overlayName !== '') {
      props.setFormData = overlayName === 'addAutomation' ? setFormData : setFormEditedData;
      props.formData = overlayName === 'addAutomation' ? formData : formEditedData;
    }

    if ((!saveBtnClicked && overlayName === '') || saveBtnClicked || overlayName !== '') {
      autohealConfiguration(props);
    }
  }, [deleteAutomation, isRefresh, searchVal, saveBtnClicked, rowID, currentPageNo, automationSearchVal, isFilter, filterArray, exportBtnClicked]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
											{ name: "Automate", link: "/home" },
                      {name:"Automation", link:"/automate/automation/all_automations"},
                      {name:"Auto-heal", link:"#"}
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal >
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomationPages("Auto-Heal")} />
                  <StackItem>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn=
                                  {
                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={
                                    <>
                                      <Body1Strong> Add a Filter </Body1Strong>
                                      <Divider />
                                      <MenuList>
                                        <Stack tokens={{ childrenGap: 5 }}>
                                          <StackItem> <Text></Text> </StackItem>
                                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                          <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                          <StackItem> <Divider /> </StackItem>
                                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                                          {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                          {(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Status") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                          {dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          <StackItem> <Divider /> </StackItem>
                                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <StackItem>
                                              <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                <Caption1> Apply </Caption1>
                                              </Button>
                                            </StackItem>

                                            <StackItem>
                                              <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                <Caption1> Cancel </Caption1>
                                              </Button>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      </MenuList>
                                    </>
                                  }
                                />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 && (
                                <Stack horizontal wrap>
                                  {filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                </Stack>
                              )}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <InfoBar showSpaces={true} title={"Autoheal is a proactive solution that automatically triggers when predefined conditions, such as an event viewer entry, error message, log file error, or registry change, are detected. It instantly executes the necessary fix, ensuring seamless resolution without manual intervention. To implement this solution, configurations must be set up in the Automation section."} />

                      </StackItem>

                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={automationOverLayData} saveBtnFunc={setSaveBtnClicked} saveBtnClicked={saveBtnClicked} isNavBtn={automationStatus !== 'not attached' ? false : true} formRef={formRef} handleOutsideButton={handleOutsideButton} handleSubmit={handleSubmit} classificationNameValidation={classificationNameValidation} />

            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveBtnClicked && overlayName == '') ? "Automation Deleted Successfully" : overlayName == 'addAutomation' ? "New Automation Created Successfully" : "Automation Edited Successfully"} footer="" />}

            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}
            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};